module.exports = __webpack_public_path__ + "static/img/browser_classting.15cd0b77.png";